import config from '../config/index'
import {isOnLine} from '../config/constantconfig'

let OSS = require('ali-oss')

let currectregion = config.dev_video_region
let currectaccessKeyId = config.dev_video_accessKeyId
let currectaccessKeySecret = config.dev_video_accessKeySecret
let currectbucket = config.dev_video_bucket
if (process.env.NODE_ENV === 'development') {
  currectregion = config.dev_video_region
  currectaccessKeyId = config.dev_video_accessKeyId
  currectaccessKeySecret = config.dev_video_accessKeySecret
  currectbucket = config.dev_video_bucket
} else if (process.env.NODE_ENV === 'debug') {
  currectregion = config.dev_video_region
  currectaccessKeyId = config.dev_video_accessKeyId
  currectaccessKeySecret = config.dev_video_accessKeySecret
  currectbucket = config.dev_video_bucket
} else if (isOnLine) {
  currectregion = config.pro_video_region
  currectaccessKeyId = config.pro_video_accessKeyId
  currectaccessKeySecret = config.pro_video_accessKeySecret
  currectbucket = config.pro_video_bucket
}

let client = new OSS({
  region: currectregion,
  accessKeyId: currectaccessKeyId,
  accessKeySecret: currectaccessKeySecret,
  bucket: currectbucket
})

async function put (objName, localfile) {
  try {
    let result = await client.put(objName, localfile)
    return result
  } catch (e) {
  }
}

function asyncput (objName, localfile) {
  return client.put(objName, localfile)
}

// 分片上传
async function multipartUpload (objName, localfile, fun) {
  try {
    let result = await client.multipartUpload(objName, localfile, {
      progress: fun
    })
    let resultinfo = {
      size: result.res.size,
      rt: result.res.rt,
      url: result.name
    }
    return resultinfo
  } catch (e) {
    // 捕获超时异常
    if (e.code === 'ConnectionTimeoutError') {
      // do ConnectionTimeoutError operation
    }
  }
}

export default {put, asyncput, multipartUpload}
